import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { Typography } from '@tkww/the-bash-frontend';

const getTitleStyles = (theme, props) => ({
  color: props.titleUrl ? theme.palette.primary.main : theme.palette.grey[300],
  textTransform: 'uppercase',
  fontSize: 11,
  fontFamily: theme.fonts.semibold,
  letterSpacing: '1px',
  '&:hover': {
    color: props.titleUrl ? theme.palette.primary.darker : theme.palette.grey[300],
  },
});

export const PhotoCopy = (props) => {
  const { title, titleUrl, className, children, align } = props;

  return (
    <Box
      sx={(theme) => ({
        margin: 0,
        textAlign: align.xs ? align.xs : 'center',
        [theme.breakpoints.up('md')]: {
          textAlign: 'left !important',
        },
      })}
      className={className}
    >
      <Box
        sx={{
          '& img': {
            borderRadius: '6px',
          },
        }}
      >
        {children}
      </Box>
      {titleUrl ? (
        <Box
          component="a"
          href={titleUrl}
          rel="noopener noreferrer"
          target="_blank"
          sx={(theme) => getTitleStyles(theme, props)}
        >
          {title}
        </Box>
      ) : (
        <Typography data-testid="image-credit" sx={(theme) => getTitleStyles(theme, props)}>
          {title}
        </Typography>
      )}
    </Box>
  );
};

PhotoCopy.propTypes = {
  title: PropTypes.string.isRequired,
  titleUrl: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
  align: PropTypes.shape({}),
};

PhotoCopy.defaultProps = {
  align: {},
  className: '',
};

export default PhotoCopy;
